export default {
  en: {
    settings: {
      title: 'Custom properties',
      supplierTitle: 'Supplier properties',
      supplierDescription:
        'Create and manage the supplier properties that you and your team need. For example, define a contract renewal date, business owner or something completely custom.',
      subEntityTitle: 'Sub-entity properties',
      subEntityDescription:
        'Create and manage the sub-entity properties that you and your team need. For example, define a region, business owner or something completely custom.',
      addButton: 'Create property',
      emptyTitle: 'No custom properties have been created yet',
      noMatching: 'No matching properties',
      noMatchingDescription: 'Try a different search or filter',
      filters: {
        entityName: 'properties',
        searchPlaceholder: 'Search properties',
      },
      error: 'There was an error retrieving the custom properties',
      retry: 'Retry',
      nullRepresentation: '—',
      nullBoolean: 'Unknown',
      table: {
        name: 'Name',
        type: 'Type',
        values: 'Values',
        createdBy: 'Created by',
        actions: 'Actions',
      },
      deleteTitle: 'Are you sure you want to delete the property {name}',
      supplierDeleteDescription: 'Deleting the property will remove it from all suppliers.',
      subEntityDeleteDescription: 'Deleting the property will remove it from all sub-entities.',
      cancel: 'Cancel',
      confirm: 'Confirm',
      errorDeleting: 'There was an error deleting the property. Please try again.',
      sidePanel: {
        title: 'Create property',
        editTitle: 'Edit property',
        name: 'Name',
        namePlaceholder: 'e.g. contract renewal date',
        duplicateName: "There's already a property with that name",
        nameRequired: 'A name is required',
        type: 'Type',
        defaultValue: 'Default value',
        optional: 'Optional',
        defaultValueDescription:
          'This value will be used for all suppliers that have not been set a value for the property',
        cancel: 'Cancel',
        add: 'Create property',
        save: 'Save changes',
        error: 'There was an error creating the property. Please try again.',
        editError: 'There was an error updating the property. Please try again.',
      },
      propertyTypes: {
        text: 'Text',
        singleSelect: 'Select',
        multiSelect: 'Multi-select',
        number: 'Number',
        website: 'URL',
        date: 'Date',
        boolean: 'Boolean',
        email: 'Email',
      },
    },
    profile: {
      edit: 'Edit {name}',
      manage: 'Manage',
      cancel: 'Cancel',
      save: 'Save',
      error: 'There was an error saving. Please try again.',
      invalidMessage: {
        number: 'Field can only contain numbers',
        website: 'Invalid URL',
        email: 'Invalid email address',
      },
    },
    dateFormat: 'dd MMMM yyyy',
    options: {
      singleSelect: {
        title: 'Select values',
        add: 'Add',
        valueLabel: 'Value {idx} label',
        noEmpty: 'Select values should not be empty',
        noEqual: 'Select values must not be equal',
      },
      deleteTitle: 'Are you sure you want to delete the value "{option}"?',
      deleteDescription:
        "Anything with this value will default to an empty value unless another is selected. This can't be undone.",
      newValue: 'New value',
      optional: 'Optional',
      cancel: 'Cancel',
      confirm: 'Confirm',
      deletePermanently: 'Delete permanently',
      errorDeleting: 'There was an error deleting this option. Try again later.',
      boolean: {
        trueFilter: 'is true',
        falseFilter: 'is false',
        true: 'True',
        false: 'False',
      },
    },
    nullRepresentation: '—',
    nullBoolean: 'Unknown',
    emptyWebsitePlaceholder: 'www.riskledger.com',
    emptyEmailPlaceholder: "hello{'@'}riskledger.com",
    activityItems: {
      valueChanged: '{user} changed {property} from {prevValue} to {newValue}',
      valueChangedNoPrevious: '{user} set {property} to {newValue}',
      deletedProperty: 'a now deleted property',
    },
  },
};
